(() => {
  const readOptimizedHeaderExperiment = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );

    const enabled = holdoutGroup !== "holdout-q3-2026";

    document.body.classList.toggle("pdm-optimized-header", enabled);

    if (!enabled) return;

    const $header = document.querySelector(".section-header");
    const $announcement = $header?.querySelector(".header-announcement");
    const $menu = $header?.querySelector(".section-header--content");
    if (!$header || !$announcement) return;

    const HIDE_THRESHOLD = 40;
    const DELTA_THRESHOLD = 6;
    const body = document.body;
    const rootStyle = document.documentElement.style;

    const publishHeights = () => {
      rootStyle.setProperty(
        "--announcement-height",
        `${$announcement.offsetHeight}px`,
      );
      if ($menu)
        rootStyle.setProperty("--menu-height", `${$menu.offsetHeight}px`);
    };
    publishHeights();
    window.addEventListener("load", publishHeights);
    window.addEventListener("resize", publishHeights, { passive: true });

    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      const currentY = window.scrollY;
      const delta = currentY - lastY;

      if (Math.abs(delta) >= DELTA_THRESHOLD) {
        if (currentY <= HIDE_THRESHOLD) {
          body.classList.remove("is-scrolled", "is-menu-visible");
        } else {
          body.classList.add("is-scrolled");
          body.classList.toggle("is-menu-visible", delta < 0);
        }
        lastY = currentY;
      }
      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScroll);
      },
      { passive: true },
    );
  };

  const readPLPBadge = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    if (holdoutGroup !== "holdout-q3-2026") {
      document.body.dataset.badge = "B";
    }
  };

  const readSidecartCheckoutPosition = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    const enabled = holdoutGroup !== "holdout-q3-2026";

    const position = enabled ? "bottom" : "top";

    if (position !== "top" && position !== "bottom") return;

    document.body.setAttribute("data-checkout-position", position);
  };

  const readATCPlpOptimization = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    const featureFlag = window._growthbook.getFeatureValue(
      "pdm-atc-plp-optimization",
      false,
    );
    const enabled = holdoutGroup !== "holdout-q3-2026";
    if (enabled && featureFlag) {
      document.body.setAttribute("atc-plp", "B");
    }
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(() => {
    const applyFeatureFlags = () => {
      readOptimizedHeaderExperiment();
      readPLPBadge();
      readSidecartCheckoutPosition();
      readATCPlpOptimization();
    };

    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
